import React                from 'react';

import * as AEVApplicationType  from '../shared/types/AEVApplication';
import dayjs                from '../shared/utils/day-timezone';

import InfiniteTable        from '../components/InfiniteTable';
import MenuItem             from '../components/MenuItem';
import intelitransit        from '../utils/InteliTransit';

import * as images          from '../images';

export class SubmissionsTable extends InfiniteTable<AEVApplicationType.Hydrated> {
    fetchRows( orderby:string, limit:number, skip:number ) {
        return this.getTablePromise<AEVApplicationType.Dehydrated[]>('/api/clerk/applications','GET',undefined,{orderby,limit,skip})
            .then( payload => {
                return payload.map(AEVApplicationType.hydrate);
            })
    }
    renderThead() {
        return (
            <tr>
                <th onClick={()=>this.sort('_id')}>{this.getSortingIcon('_id')}Id</th>
                <th onClick={()=>this.sort('createdAt')}>{this.getSortingIcon('createdAt')}Created</th>
                <th onClick={()=>this.sort('updatedAt')}>{this.getSortingIcon('updatedAt')}Updated</th>
                <th>Applicant</th>
                <th>Questionnaire</th>
                <th>Review</th>
            </tr>
        )
    }
    renderRow( app:AEVApplicationType.Application ) {
        const getApplicantData = ( applicant:AEVApplicationType.Applicant ) => {
            return {
                "First Name"    : applicant.fname,
                "Last Name"     : applicant.lname,
                "Mail Address"  : applicant.mailAddress,
                "Home Address"  : applicant.homeAddress,
                "D.O.B"         : dayjs(applicant.dob).tz(intelitransit.agency.timeZone).format("MM/DD/YYYY"),
                "Email Address" : applicant.emailAddress,
                "Phone Number"  : applicant.phoneNumber
            }
        };
        return (
            <tr key={app._id} style={{ verticalAlign:'top'}}>
                <td align='left' style={{verticalAlign:'top'}}>
                    {app._id}
                </td>
                <td align='left' style={{verticalAlign:'top'}}>
                    {dayjs(app.createdAt).tz(intelitransit.agency.timeZone).format(intelitransit.timeFormat)}
                </td>
                <td align='left' style={{verticalAlign:'top'}}>
                    {dayjs(app.updatedAt).tz(intelitransit.agency.timeZone).format(intelitransit.timeFormat)}
                </td>
                <td align='left' style={{verticalAlign:'top'}}>
                    { app.applicant ? (
                        <table>
                        <tbody>
                        {Object.entries(getApplicantData(app.applicant)).map(([name,value]) => {
                            return (
                                <tr key={name}>
                                    <td align='left' valign='top'>{name}</td>
                                    <td align='left' valign='top'>{value}</td>
                                </tr>
                            );
                        })}
                        </tbody>
                        </table>
                    ) : "n/a" }
                </td>
                <td align='left' style={{verticalAlign:'top'}}>
                    <table>
                    <tbody>
                        {Object.entries(app.questionnaire).map(([q,a],ndx) => {
                            return (<tr key={q}>
                                <td align='left' valign='top'>{q}</td>
                                <td align='left' valign='top'>{a}</td>
                            </tr>);
                        })}
                    </tbody>
                    </table>
                </td>
                <td align='left' style={{verticalAlign:'top'}}>
                    { app.review ? (
                        <table>
                        <tbody>
                            <tr>
                                <td>At</td>
                                <td>{dayjs(app.review.at).tz(intelitransit.agency.timeZone).format(intelitransit.timeFormat)}</td>
                            </tr>
                            <tr>
                                <td>Clerk</td>
                                <td>{app.review.clerkId}</td>
                            </tr>
                            <tr>
                                <td>Decision</td>
                                <td>{app.review.decision}</td>
                            </tr>
                        </tbody>
                        </table>
                    ) : (
                        <button className="btn-theme btn-min" onClick={(e:React.MouseEvent<HTMLButtonElement>)=>{
                            this.alert.set(`Not ready!`,3000);
                        }}>Review</button>
                    ) }
                </td>
            </tr>
        );
    }
}

export const Submissions : React.FC<{}> = props => {
    return (
        <MenuItem title={["Submissions",<a key='download' href='/api/clerk/applications?csv'><images.Download/></a>]}>
            <SubmissionsTable/>
        </MenuItem>
    );
}

export default Submissions;